import Aqumen from "@aqumen/sdk";

import {Query} from "@/data/query.js";

export async function fetchUser(session, id) {
  const users = await Aqumen.User.all(session, Query.User.selection, {users: {id}});
  return users?.[0];
}
